const items = ["The Party Pet Shop", "Will the mouse save the day?!", "Ages 3–8", "Written by Reuben, age 6", "Not your average pet shop", "Full of giggles"];

const Row = () => (
  <div className="flex shrink-0 items-center gap-10 pr-10">
    {items.map((t) => (
      <span key={t} className="flex items-center gap-10 font-display text-3xl sm:text-5xl text-ink whitespace-nowrap">
        {t}
        <svg viewBox="0 0 24 24" className="w-6 h-6 sm:w-8 sm:h-8 text-coral" aria-hidden="true">
          <path fill="currentColor" d="M12 2l2.6 6.6L21 9.3l-5 4.4 1.5 6.8L12 17l-5.5 3.5L8 13.7 3 9.3l6.4-.7z" />
        </svg>
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <div className="relative bg-butter border-y-2 border-ink py-5 overflow-hidden -rotate-1 scale-[1.02]" data-testid="marquee">
    <div className="flex w-max animate-marquee">
      <Row />
      <Row />
    </div>
  </div>
);
